// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1_SQf","cls2":"Comments-cls2__hc Comments-cls1_SQf"};